<h2 mat-dialog-title>Eliminar</h2>
<mat-dialog-content>
  <p>¿Esta seguro de realizar la eliminacion de {{count > 1 ?'los siguientes elementos' : 'el siguiente elemento'}}?</p>

  <p>{{elementNames}}</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button mat-dialog-close cdkFocusInitial>Cancelar</button>
  <button mat-button [mat-dialog-close]="true" >Ejecutar eliminacion</button>
</mat-dialog-actions>
